import { Modal, Button } from "@evertrue/et-components";
import EmailSignaturesLibrary from "./email-signatures-library";
import EmailSignaturesForm from "./email-signatures-form";
import { useState } from "react";
import PropTypes from "prop-types";

const MOCK_SIGNATURES = [
  {
    id: 1,
    name: "Signature 1",
    body: "<p>Signature 1</p>",
  },
  {
    id: 2,
    name: "Signature 2",
    body: "<p>Signature 2</p>",
  },
  {
    id: 3,
    name: "Signature 3",
    body: "<p>Signature 3</p>",
  },
];

const EmailSignaturesModal = ({ isOpen, onClose }) => {
  const [selectedSignature, setSelectedSignature] = useState(MOCK_SIGNATURES[0]);

  return (
    <Modal isOpen={isOpen} closeModal={onClose} size="1000px">
      <div className="signatures-modal--header">
        <h3>Signature</h3>
        <Button onClick={onClose}>Done</Button>
      </div>
      <div style={{ display: "flex" }}>
        <EmailSignaturesLibrary
          selectedSignature={selectedSignature}
          setSelectedSignature={setSelectedSignature}
          signatures={MOCK_SIGNATURES}
        />
        <EmailSignaturesForm selectedSignature={selectedSignature} />
      </div>
    </Modal>
  );
};

EmailSignaturesModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default EmailSignaturesModal;
